import { Container, IDestroyOptions, Sprite, Text, TextStyle, Texture } from "pixi.js";
import { CardCostContainer } from "./CardCostContainer";
import { gsap } from "gsap";
type Timeline = gsap.core.Timeline;

export class CardCostContainerWithHint extends CardCostContainer {
    private static readonly COST_HINT_TEXT = "This is the cost\nper visit";

    private hintContainer: Container;
    private hintText: Text;
    private hintLeftArrow: Sprite;
    private hintTargetContainer: Container;

    public constructor(value: number,
        iconTexture: Texture,
        hintLeftArrowTexture: Texture
    ) {
        super(value, iconTexture);
        this.build(hintLeftArrowTexture);
        this.once("added", this.hideHints.bind(this));
    }

    private build(hintLeftArrowTexture: Texture): void {
        this.hintTargetContainer = new Container();
        this.hintTargetContainer.addChild(this.costContainer);
        this.addChild(this.hintTargetContainer);
        this.hintContainer = new Container();
        this.addChild(this.hintContainer);
        this.hintText = new Text(CardCostContainerWithHint.COST_HINT_TEXT, new HintTextStyle());
        this.hintText.anchor.set(0.5, 0.5);
        this.hintText.angle = -13;
        this.hintContainer.addChild(this.hintText);
        this.hintLeftArrow = new Sprite(hintLeftArrowTexture);
        this.hintLeftArrow.anchor.set(0, 0);
        this.hintLeftArrow.angle = 160;
        this.hintLeftArrow.position.set(this.hintText.x - this.hintText.width * 0.1, this.hintText.y - this.hintText.height * 0.25);
        this.hintContainer.addChild(this.hintLeftArrow);
        this.hintContainer.position.set(this.costContainer.x - this.costContainer.width * 0.1, this.costContainer.y + this.hintContainer.height * 0.6);
    }

    private hideHints(): void {
        this.hintContainer.visible = false;
    }

    public getHintAnimation(): Timeline {
        const animationTimeLine = new gsap.core.Timeline();
        animationTimeLine.set(this.hintContainer, { visible: true });
        animationTimeLine.fromTo(this.hintText.scale, { x: 0, y: 0 }, { x: 1, y: 1, duration: 0.3, ease: "back.out(2)" });
        animationTimeLine.fromTo(this.hintLeftArrow.scale, { x: 0, y: 0 }, { x: 1, y: 1, duration: 0.3, ease: "back.out(2)" });
        animationTimeLine.fromTo(this.hintTargetContainer.scale, { x: this.hintTargetContainer.scale.x, y: this.hintTargetContainer.scale.y }, { x: 1.7, y: 1.7, duration: 0.3 }, "<");
        animationTimeLine.to(this.costText.style, { fill: "#ffffff", duration: 0.3 }, "<");
        animationTimeLine.to(this.hintContainer.scale, { x: 0, y: 0, duration: 0.3, delay: 2, ease: "back.in(2)" });
        animationTimeLine.to(this.hintTargetContainer.scale, { x: 1, y: 1, duration: 0.4 }, "<");
        animationTimeLine.to(this.costText.style, { fill: "#000000", duration: 0.4 }, "<");
        animationTimeLine.then(() => animationTimeLine.kill());
        return animationTimeLine;
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        super.destroy(options);
    }
}

class HintTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            fontFamily: "Grapenuts Regular",
            fill: "#ffffff",
            fontSize: 80,
            align: "center"
        }));
    }
}
